<template>
    <div id="deposit-farm-component" :class="mode == 'dark' ? 'dark' : 'light'">
        <div class="uk-flex uk-flex-center uk-margin-remove">
            <img src="@/assets/chad_hat_hires.png" alt="" width="100" height="100">
        </div>
        <h2 class="uk-text-center uk-mergin-remove-top">Deposit and farm your assets</h2>
        <stats :mode="mode"></stats>
        <section class="uk-section uk-padding-small">
            <div class="uk-grid-row-collapse uk-child-width-1-3@m uk-grid-match" uk-grid>
                <farm-card
                    v-for="card in this.cards" :key="card.farmTitle"
                    :mode="mode"
                    :cryptoLogo="card.cryptoLogo"
                    :farmTitle="card.farmTitle"
                    :farmAPY="card.farmAPY"
                    :lps="card.lps">

                </farm-card>
            </div>
        </section>
    </div>    
</template>

<script>
import Stats from "@/components/reusables/Stats";
import FarmCard from "@/components/reusables/FarmCard";
import { farms } from "@/utils/Farms";

export default {
    name: 'DepositFarm',
    props: {
        mode: String
    },
    components: {
        'stats': Stats,
        'farm-card': FarmCard
    },
    data: function() {
        return {
            cards: farms
        }
    }
}
</script>

<style lang="less" scoped>
    @import "../dark-components/deposit-farm.less";
    
    h2 {
        font-family: 'Lato';
        font-weight: 900;
        .fluid-font(1.5, 64, 320, 3840);
        color: @text-color;
    }
</style>